import React from "react";

const PayrollProcess = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
    <path d="M34 28.488H12.796L8.359 9.94h21.204L34 28.49z" fill="#D58B00" />
    <path
        d="M3.915 28.488H25.12L29.555 9.94H8.351L3.915 28.49z"
        fill="#FFA700"
    />
    <path
        d="M5.368 27.436h18.8l3.934-16.446h-18.8L5.368 27.436z"
        fill="#fff"
    />
    <path
        d="M24.79 15.401h1.746l.366-1.528h-1.747l-.366 1.528zM22.146 15.401h1.747l.366-1.528h-1.747l-.366 1.528zM19.471 15.401h1.748l.365-1.528h-1.747l-.366 1.528zM16.798 15.401h1.747l.365-1.528h-1.747l-.365 1.528zM14.124 15.401h1.747l.365-1.528H14.49l-.365 1.528zM11.45 15.401h1.747l.365-1.528h-1.747L11.45 15.4zM8.775 15.401h1.748l.365-1.528H9.141L8.775 15.4zM24.061 18.105h1.747l.365-1.528h-1.747l-.365 1.528zM21.417 18.105h1.747l.365-1.528h-1.747l-.365 1.528zM18.744 18.105h1.747l.365-1.528H19.11l-.366 1.528zM16.07 18.105h1.747l.365-1.528h-1.747l-.365 1.528zM13.395 18.105h1.747l.366-1.528H13.76l-.366 1.528zM10.721 18.105h1.747l.366-1.528h-1.748l-.365 1.528zM8.047 18.105h1.747l.365-1.528H8.412l-.365 1.528zM23.399 20.776h1.747l.365-1.528h-1.747l-.365 1.528zM20.755 20.776h1.747l.366-1.528H21.12l-.366 1.528zM18.081 20.776h1.747l.366-1.528h-1.748l-.365 1.528zM15.407 20.776h1.747l.365-1.528h-1.747l-.365 1.528zM12.732 20.776h1.748l.365-1.528h-1.747l-.366 1.528zM10.059 20.776h1.747l.365-1.528h-1.747l-.365 1.528zM7.384 20.776h1.747l.366-1.528H7.75l-.366 1.528zM22.736 23.379h1.747l.366-1.529h-1.747l-.366 1.529zM20.093 23.379h1.747l.365-1.529h-1.747l-.365 1.529zM17.419 23.379h1.747l.365-1.529h-1.747l-.365 1.529zM14.745 23.379h1.747l.365-1.529H15.11l-.365 1.529zM12.07 23.379h1.747l.366-1.529h-1.747l-.366 1.529zM9.396 23.379h1.747l.366-1.529H9.762l-.366 1.529zM6.723 23.379H8.47l.365-1.529H7.088l-.365 1.529zM22.107 25.948h1.747l.365-1.528h-1.747l-.365 1.528zM19.464 25.948h1.747l.365-1.528H19.83l-.365 1.528zM16.789 25.948h1.747l.366-1.528h-1.748l-.365 1.528z"
        fill="#AFCDFB"
    />
    <path d="M34 28.487l-4.504-.882-4.377.882H34z" fill="#CB8500" />
    <path
        d="M25.807 8c1.063 0 1.931.868 1.961 1.946h-.785A1.19 1.19 0 0025.807 8.8c-.65 0-1.178.54-1.178 1.202 0 .663.528 1.202 1.178 1.202.217 0 .393.18.393.4 0 .222-.176.401-.393.401-1.082 0-1.962-.898-1.962-2.003S24.724 8 25.806 8zM20.835 8c1.063 0 1.931.868 1.961 1.946h-.785A1.19 1.19 0 0020.835 8.8c-.65 0-1.178.54-1.178 1.202 0 .663.529 1.202 1.178 1.202.217 0 .392.18.392.4 0 .222-.175.401-.392.401-1.082 0-1.963-.898-1.963-2.003S19.753 8 20.835 8zM15.864 8c1.063 0 1.931.868 1.961 1.946h-.785A1.19 1.19 0 0015.864 8.8c-.65 0-1.178.54-1.178 1.202 0 .663.529 1.202 1.178 1.202.217 0 .392.18.392.4 0 .222-.175.401-.392.401-1.082 0-1.962-.898-1.962-2.003S14.782 8 15.864 8zM10.893 8c1.063 0 1.93.868 1.96 1.946h-.784A1.19 1.19 0 0010.893 8.8c-.65 0-1.178.54-1.178 1.202 0 .663.528 1.202 1.178 1.202.216 0 .392.18.392.4 0 .222-.175.401-.392.401-1.082 0-1.963-.898-1.963-2.003S9.81 8 10.893 8z"
        fill="#1E2538"
    />
    <path
        d="M29.555 9.94l-.06 17.666 4.504.882L29.555 9.94z"
        fill="#FFA700"
    />
    <path
        d="M15.57 16.392a4.35 4.35 0 01-1.914.133c-.552-.094-.924-.405-1.022-.75-.088-.313.043-.663.379-1.014-.323.336-.436.723-.355 1.007.09.315.445.548.976.639.544.093 1.216.034 1.892-.166.676-.2 1.275-.518 1.686-.894.4-.367.58-.758.49-1.073-.095-.334-.495-.666-1.043-.866-.622-.227-1.297-.18-1.935.009-1.198.355-1.614.771-1.945 1.237.333-.468.71-.998 1.912-1.354a3.156 3.156 0 011.963.06c.56.204.97.552 1.071.907.098.345-.078.744-.494 1.126-.413.377-.984.799-1.662 1z"
        fill="#FF6961"
    />
    <path
        d="M3.485 18.74s.054.54.114.643c.06.103.315.43.424.495.108.064-.067-.432-.045-.528.022-.097.09.176.138.182.047.007.035-.239.037-.328.001-.09-.233-.31-.316-.5-.082-.19-.352.035-.352.035zM10.006 13.742l.122-.235s-.06-.418.454-.683c0 0 .187-.078.293.078.098.144-.186.118-.17.365.014.246-.1.39-.26.47l-.131.157-.308-.152z"
        fill="#FFB27D"
    />
    <path
        d="M5.149 13.181s.441 2.211 2.87 2.934c.758.225 2.48-2.322 2.48-2.322s-.06-.235-.44-.181c0 0-1.676 1.133-1.887 1.256-.188.11-1.42-1.404-1.982-1.648-.561-.244-1.041-.039-1.041-.039z"
        fill="#AA413E"
    />
    <path
        d="M9.357 13.1l.069.459 2.255-.354-.07-.458-2.254.354z"
        fill="#AA413E"
    />
    <path
        d="M12.171 12.893l-.49.311-.068-.457.558.146zM9.117 13.292l.022.145a.16.16 0 00.182.136l.104-.016-.068-.458-.114.018a.154.154 0 00-.126.175z"
        fill="#FFB27D"
    />
    <path
        d="M2.25 27.078s-.301.28-.242.48c.058.2.33.333.367.576.037.244.184.377.316.377h.63s.098-.171-.137-.223c-.235-.052-.324-.338-.31-.604.015-.266-.021-.62-.021-.62l-.5-.118-.103.132zM5.947 27.806s-.054.639.078.705l1.693-.004s0-.199-.272-.243c-.272-.044-.75-.207-.83-.569-.082-.362-.67.11-.67.11z"
        fill="#233862"
    />
    <path
        d="M7.376 18.784s-.09 1.12-.195 2.465c-.142 1.828-.314 4.074-.33 4.5-.03.738-.148 1.92-.148 1.92s-.279.28-.838.162c0 0-.497-1.687-.64-3.472l-.006-.088a428.018 428.018 0 01-.338-5.642l2.495.155z"
        fill="#1E2538"
    />
    <path
        d="M7.376 18.784s-.09 1.119-.195 2.465l-1.956 3.11-.006-.088a428.018 428.018 0 01-.338-5.642l2.495.155z"
        fill="#233862"
    />
    <path
        d="M6.968 18.916s-1.61 4.055-2.668 5.96c-1.058 1.905-1.388 2.437-1.388 2.437s-.607-.243-.662-.41c0 0 .405-3.678 1.114-4.575.4-.506.87-2.027.893-2.559a30.52 30.52 0 01.143-1.584l2.568.731z"
        fill="#1E2538"
    />
    <path
        d="M4.85 12.668s1.09.536 1.717.337c0 0-.154-.2-.425-.347.022-.129.039-.24.049-.335.026-.218.026-.342.026-.342l-.42-.337-.398-.323c.03.908-.548 1.347-.548 1.347z"
        fill="#FFB27D"
    />
    <path
        d="M4.276 18.393c-.002.068.14.146.203.175.466.209.9.354 1.393.403.582.06 1.27-.073 1.507-.068.024 0 .046-.01.065-.027.017-.012.029-.728.017-1.628 0-.037 0-.073-.003-.11v-.011c-.005-.352-.017-.721-.033-1.09-.034-.81-.097-1.592-.203-2.024-.128-.51-.418-.847-.681-1.092l-.217-.194a1.024 1.024 0 01-.676-.082c-.252-.124-.522-.258-.565-.223-.329.244-.55.795-.67 1.5a7.952 7.952 0 00-.098 1.334c0 .174.005.354.014.531.058.961 0 1.796-.034 2.279-.01.14-.016.25-.019.327z"
        fill="#FF6961"
    />
    <path
        d="M4.295 18.35C8.11 18.34 5 14.125 5 14.125l-.618-.205c-.049.433-.073.918-.072 1.426 0 .187.004.378.01.568.043 1.026 0 1.918-.024 2.434z"
        fill="#AA413E"
    />
    <path
        d="M5.391 11.668s.275.512.8.656c.026-.219.026-.342.026-.342l-.42-.338-.406.024z"
        fill="#ED985F"
    />
    <path
        d="M6.408 11.966s-1.039.174-1.136-.478c-.098-.652-.298-1.068.362-1.207.659-.138.825.091.91.301.086.21.132 1.323-.136 1.384z"
        fill="#FFB27D"
    />
    <path
        d="M4.895 10.204c-.01-.012-.031-.02-.08-.023 0 0 .04-.025.09-.026.011-.069.047-.19.163-.22 0 0-.063.034-.07.107.133-.14.42-.243 1.217-.179 1.05.084.704.77.568.852-.136.082-.478-.142-.73-.122-.254.02-.302.394-.388.445-.086.051-.052-.04-.168-.093-.116-.054-.127.143-.094.27.034.128-.126.297-.126.297l-.161-.177c-.161-.178-.313-.929-.24-1.089l.019-.043z"
        fill="#2C3A64"
    />
    <path
        d="M5.083 12.416s-.657.318-.972.806c-.489.758-1.056 3.518-1.066 3.774-.01.256.413 2.06.413 2.06s.43-.028.541-.25c0 0-.086-1.855-.031-1.974.054-.12 1.793-2.488 1.597-2.993-.195-.505-.482-1.423-.482-1.423z"
        fill="#FF6961"
    />
    <path
        d="M10.13 13.496s-.035-.144.063-.209c.097-.064.188-.24.229-.217.085.05-.047.203-.023.395.009.067-.145.243-.269.031z"
        fill="#FFB27D"
    />
    </svg>
);

export default PayrollProcess;
